import { StyleSheet } from 'react-native'
import { ApplicationStyles, Colors } from '../../Themes'

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  brandingContainer: {
    width: '100%',
    justifyContent: 'center',
    backgroundColor: Colors.appBg,
  },
})
